(() => {
  const units = {
    second: 1000,
    minute: 60000,
    hour: 3600000,
    day: 86400000,
    week: 604800000,
    month: 2592000000,
    year: 31536000000,
  };

  window.swinger.observer.initialize('.swinger-timeago', (elem) => {
    try {
      const rtf = new Intl.RelativeTimeFormat(window.swinger.config.language, { style: 'long' });
      const now = new Date().getTime();
      const date = new Date(elem.getAttribute('datetime')).getTime();
      const difference = date - now;
      const unit = Object.keys(units).reduce((acc, unit) => {
        if (Math.abs(difference) > units[unit]) {
          return unit;
        }

        return acc;
      }, 'day');

      window.requestAnimationFrame(() => {
        try {
          elem.textContent = rtf.format(Math.ceil(difference / units[unit]), unit);
        } catch (e) {
          // noop
        }
        elem.classList.add('swinger-timeago--show');
      });
    } catch (e) {
      elem.classList.add('swinger-timeago--show');
    }
  }, false);
})();
